import { Theme } from "@emotion/react";
import { SxProps, TypographyVariant } from "@mui/material";
import {
    Typography,
} from "@mui/material";
import React, { ReactNode } from "react";

interface ThypographyProps {
    sx?: SxProps<Theme>;
    children: ReactNode;
    variant?: TypographyVariant;

    fontWeight?: string;
    mt?: number;
    mb?: number;
    color?: string;
}

const TypographyComponent = (props: ThypographyProps) => {
    return <Typography
        variant={props.variant}
        fontWeight={props.fontWeight}
        mt={props.mt} mb={props.mb}
        color={props.color}
        sx={props.sx}
    >
        {props.children}
    </Typography>
}

export default TypographyComponent;